module.exports = __webpack_public_path__ + "static/img/dash-7.f5c1ba66.png";